import React from 'react';
import { ThemeProvider, useTheme } from '../Contexts/ThemeContext';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { Page } from '@aidkitorg/component-library';

// TODO: use AppShell to build out an OverviewPage -- this is just temporary to test out the ThemeProvider
const OverviewPage = () => {  
  const {logo} = useTheme();
  return (
    <Page>
      <div>Content {logo}</div>
    </Page>
  )
}

export const AdminPanelApp = () => {
  let { path } = useRouteMatch();

  return (
    <ThemeProvider>
      <Switch>
        <Route path={`${path}/overview`} component={OverviewPage} />
      </Switch>
    </ThemeProvider>      
  )
}

export default AdminPanelApp;